<template>
  <div :class="['form-group', cssClass]">
    <label>{{ label }}</label>
    <input
      :type="type"
      :ref="name"
      :name="name"
      v-model="inputVal"
      :class="['form-control', { 'is-danger': error.length > 0 }]"
    />
    <message :name="name" :show="error.length > 0" :erro="error" />
  </div>
</template>

<script>
import Message from './MensagemErro'

export default {
  components: {
    Message
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    cssClass: {
      type: String,
      default: 'col-xs-12 col-sm-6 col-md-3'
    },
    value: {},
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    error: {
      type: String,
      default: ''
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/admin/concursos/edital/InputVagas.vue